export default __webpack_public_path__ + "static/char-s-46-ko-430899a6906892b66a664832e05f7d86.png";